var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { textStyle } from './styles';
function TextInternal(_a, ref) {
    var as = _a.as, children = _a.children, _b = _a.size, size = _b === void 0 ? 'medium' : _b, restProps = __rest(_a, ["as", "children", "size"]);
    var Element = as !== null && as !== void 0 ? as : 'span';
    return (_jsx(Element, __assign({ css: textStyle({ size: size }), ref: ref }, restProps, { children: children })));
}
export default TextInternal;
